import moment from "moment-timezone";
class MetricsHelper {
  static buildFilterString(filterValue) {
    if (filterValue == "whatsapp") {
      return "attributes.messageEngine=whatsapp";
    } else if (filterValue == "pinpoint") {
      return "attributes.messageEngine=pinpoint";
    } else if (filterValue == "pmap") {
      return "attributes.isPmapInstance(boolean)=true"; // isPmapInstance has to exist and have value true
    } else if (filterValue == "map") {
      // "attributes.isPmapInstance(boolean)=false", This won't work, won't get those programs that are not pmap, as
      // there are programs with no isPmapInstance key to be compared with value false and bring up the records we want
      return "attributes.isMapInstance(boolean)=true";
    } else if (filterValue == "US" || filterValue == "CA") {
      return `attributes.message.settings.default.countryCode=${filterValue}`;
    } else {
      return null;
    }
  }

  static shapeBarMethod(payload, graph, query_params) {
    payload.groupBy = query_params.groupBy;
    payload.groupByTime = query_params.groupByTime;

    if (!payload.data.length)
      return [];

    let bar_data = {
      labels: [],
      datasets: [],
    }
    let filtered_datakeys = [];

    payload.dataKeys.forEach((element) => {
      filtered_datakeys.push(element);
    });

    let inter_datasets = [];
    let labelConverter = graph.convertLabel || MetricsHelper.convertLabel;
    filtered_datakeys.forEach((element) => {
      let item = {
        label: element,
        backgroundColor: MetricsHelper.getColor(element),
        data: [],
      };

      item.label = labelConverter(element);

      payload.data.forEach((period) => {
        filtered_datakeys.forEach((element0) => {
          if (
            period.hasOwnProperty(element0) &&
            !bar_data.labels.includes(period[payload.groupByTime])
          ) {
            bar_data.labels.push(period[payload.groupByTime]);
          }
        });
        if (period.hasOwnProperty(element)) {
          item.data.push(period[element]);
        } else {
          item.data.push(0);
        }
      });
      inter_datasets.push(item);
    });
    // In case we want to remove zero values from the graph.
    // bar_data.datasets = removeZeros(inter_datasets);
    // Instead, we want to add all those dates in between the selected range even though their value is zero.
    bar_data.datasets = inter_datasets;
    let bar_data0 = {
      labels: [],
      datasets: null
    }
    bar_data0.datasets = JSON.parse(JSON.stringify(bar_data.datasets));
    bar_data0.datasets[0].data = [];
    var a = moment(payload.fromDate);
    var b = moment(payload.toDate);

    switch (payload.groupByTime) {
      case 'day':
        for (let m = moment(a); m.isSameOrBefore(b); m.add(1, 'days'))
          bar_data0.labels.push(m.format('YYYY-MM-DD'));
        break;
      case 'month':
        for (let m = moment(a); m.isSameOrBefore(b); m.add(1, 'months'))
          bar_data0.labels.push(m.format('YYYY-MM'));
        break;
      default: // Year
        for (let m = moment(a); m.isSameOrBefore(b); m.add(1, 'years'))
          bar_data0.labels.push(m.format('YYYY'));
    }

    // Create a map of the existing labels and their indices in the array
    const labelMap = new Map(bar_data.labels.map((label, index) => [label, index]));
    // Add missing bar_data0.labels to the labels array
    bar_data0.labels.forEach(date => {
      if (!labelMap.has(date)) {
        bar_data.labels.push(date);
        labelMap.set(date, bar_data.labels.length - 1);
      }
    });
    // Sort the labels array in ascending order
    bar_data.labels.sort();
    // Update the data arrays to include the missing bar_data0.labels
    bar_data.datasets.forEach(dataset => {
      const newData = [];
      bar_data0.labels.forEach(date => {
        const index = labelMap.get(date);
        newData.push((index !== undefined) ? dataset.data[index] || 0 : 0);
      });
      dataset.data = newData;
    });
    bar_data0 = bar_data;
    return bar_data0;
  }

  static shapePieMethod(payload, graph) {
    let pieDataSet = {
      labels: [],
      datasets: []
    }

    if (!graph.labelField) {
      graph.labelField = "instanceName";
    }

    let pieData = [];
    let pieColours = [];
    let pieLabels = [];
    payload.data.forEach(element => {
      pieData.push(element.total);
      pieColours.push('#' + (Math.random() * 0xFFFFFF << 0).toString(16));

      //const substring = getSubstring(element, ".", ".")
      pieLabels.push(element[graph.labelField])
    })

    pieDataSet.labels = pieLabels
    pieDataSet.datasets = [
      {
        backgroundColor: pieColours,
        data: pieData
      }
    ]
    return pieDataSet;
  }

  static shapeInteractionsPieData(payload, graph) {
    if (!payload.data.length)
      return {};

    // Group data by instance
    let preFormated = {
      in: 0,
      out: 0,
    };
    payload.data.forEach((d) => {
      if (d.messageOptOut) {
        preFormated.out = d.total;
      } else {
        preFormated.in += d.total;
      }
    });

    const inColor = MetricsHelper.getColor("deliveryStatus.SUCCESSFUL.total");
    const outColor = MetricsHelper.getColor("deliveryStatus.NOT_ALLOWED_NUMBER.total");

    return {
      labels: ["Opt in", "Opt out"],
      datasets: [{
        data: [preFormated.in, preFormated.out],
        backgroundColor: [inColor, outColor]
      }]
    };
  }

  static shapeBarPhoneNumMethod(payload, graph) {
    let bar_data = {
      labels: [],
      datasets: [{
        "label": graph.labels[0],
        "backgroundColor": "#d4edda",
        "data": []
      }, {
        "label": graph.labels[1],
        "backgroundColor": "#b3cde0",
        "data": []
      }],
    }

    payload.data.forEach((element) => {
      let index = bar_data.labels.findIndex(label => label === element.instanceName);
      if (element.hasOwnProperty(graph.attr) && element[graph.attr]) {
        if (index === -1) {
          bar_data.datasets[1].data.push(element.total);
          bar_data.datasets[0].data.push(0);
          bar_data.labels.push(element.instanceName);
        } else {
          bar_data.datasets[1].data[index] = element.total;
        }
      } else {
        if (index === -1) {
          bar_data.datasets[0].data.push(element.total);
          bar_data.datasets[1].data.push(0);
          bar_data.labels.push(element.instanceName);
        } else {
          bar_data.datasets[0].data[index] = element.total;
        }
      }
    });

    if (graph.switch_data) {
      let tmp = bar_data.datasets[1].data;
      bar_data.datasets[1].data = bar_data.datasets[0].data;
      bar_data.datasets[0].data = tmp;
    }
    return bar_data;
  }

  static shapeValidPieData(payload, graph) {
    if (!payload.data.length)
      return {}

    // Group data by instance
    let preFormated = {
      valid: 0,
      invalid: 0,
    };
    payload.data.forEach((d) => {
      if (d.valid) {
        preFormated.valid = d.total;
      } else {
        preFormated.invalid = d.total;
      }
    });

    const inColor = MetricsHelper.getColor("deliveryStatus.SUCCESSFUL.total");
    const outColor = MetricsHelper.getColor("deliveryStatus.NOT_ALLOWED_NUMBER.total");

    return {
      labels: ["Valid", "Invalid"],
      datasets: [{
        data: [preFormated.valid, preFormated.invalid],
        backgroundColor: [inColor, outColor]
      }]
    };
  }

  static convertLabel(e) {
    e = e.replace("deliveryStatus.", "");
    e = e.replace(".total", "");

    return e;
  }

  static getColor(e) {
    let color;
    switch (e) {
      case "deliveryStatus.SUCCESSFUL.total":
        color = "#d4edda";
        break;
      case "deliveryStatus.None.total":
        color = "#b3cde0";
        break;
      case "deliveryStatus.USER_OPTED_OUT.total":
        color = "#d3d3d3";
        break;
      case "deliveryStatus.NOT_ALLOWED_NUMBER.total":
        color = "#f8d7da";
        break;
      case "deliveryStatus.PERMANENT_FAILURE.total":
        color = "#e84343";
        break;
      case "deliveryStatus.USER_NOT_OPTED_IN.total":
        color = "#ead957";
        break;
      case "deliveryStatus.INVALID_NUMBER.total":
        color = "#doaddf";
        break;
      default:
        color = MetricsHelper.generateRandomColor();
    }
    return color;
  }

  static getLabel(e) {
    let label;
    switch (e) {
      case "deliveryStatus.SUCCESSFUL.total":
        label = "Successful";
        break;
      case "deliveryStatus.None.total":
        label = "None";
        break;
      case "deliveryStatus.USER_OPTED_OUT.total":
        label = "User opt-out";
        break;
      case "deliveryStatus.NOT_ALLOWED_NUMBER.total":
        label = "Not allowed number";
        break;
      case "deliveryStatus.PERMANENT_FAILURE.total":
        label = "Permanent failure";
        break;
      case "deliveryStatus.USER_NOT_OPTED_IN.total":
        label = "User not opted-in";
        break;
      case "deliveryStatus.INVALID_NUMBER.total":
        label = "Invalid number";
        break;
      default:
        label = "Not known";
    }
    return label;
  }

  static generateRandomColor() {
    let maxVal = 0xFFFFFF;
    let randomNumber = Math.random() * maxVal;
    randomNumber = Math.floor(randomNumber);
    randomNumber = randomNumber.toString(16);
    let randColor = randomNumber.padStart(6, 0);
    return `#${randColor.toUpperCase()}`
  }
}

export default MetricsHelper;
